/**
 * @author:
 * @file: description
 * @Date: 2020-05-06 18:00:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-05-26 17:36:47
 */
import { EventCenter } from '@tkit/event';
import * as React from 'react';
import { connect } from 'react-redux';
import './SFCCheckLoginStatus.less';

import { IRootState } from '@src/types';

import login from '@src/utils/login';
import { i18n } from '@src/utils';
import { isValidUserInfo } from '../consts';

type StateProps = ReturnType<typeof mapStateToProps>;

export interface ISFCCheckLoginStatusProps {
  Cp: React.ComponentType<any>;
  passProps: any;
  children?: React.ReactNode;
}
type Props = StateProps & ISFCCheckLoginStatusProps;

EventCenter.once('common.user.failed', () => {
  // location.href = login();
});

export const SFCCheckLoginStatus: React.SFC<Props> = (props: Props) => {
  const { userInfo, userRes, Cp, passProps, children, firstLoginStatusCheck } = props;
  const { code } = userRes || { code: 0 };
  const isNotLogin = code === 302 || code === 401 || code === 10001;
  if (!isValidUserInfo(userInfo) && userRes) {
    if (isNotLogin) {
      EventCenter.emit('common.user.failed');
    }
  }
  return isValidUserInfo(userInfo) && !code ? (
    <Cp {...passProps}>{passProps.children || children}</Cp>
  ) : (
    <div className="common-presenter k-common-check-login-status">
      {userRes ? (
        firstLoginStatusCheck === false ? (
          <span className="k-common-check-login-status--error">
            {i18n('common.user.fail', '拉取用户信息失败，错误码“{code}”', { code })}，请尝试&nbsp;
            <a onClick={() => location.reload()}>刷新</a>
            {/* <a href={login()}>登录</a> */}
          </span>
        ) : null
      ) : (
        <div className="k-common-loading">loading...</div>
      )}
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state: IRootState) {
  return {
    userInfo: state.common.userInfo,
    userRes: state.common.userRes,
    firstLoginStatusCheck: state.common.firstLoginStatusCheck
  };
}
export default connect<StateProps, never, ISFCCheckLoginStatusProps>(mapStateToProps)(
  SFCCheckLoginStatus
);
